/** Plans & entitlements (ALP-81): gates, near-limit banners, Settings → Plan & usage, admin plans console labels. Owned by the plans web track. */
export const plans = {
  gate: {
    notInPlan: "Not included in your plan",
    limitReached: "You reached your plan limit",
    upgrade: "Upgrade",
    lockedCopilot: "The Assistant isn't included in your plan.",
    lockedTitle: "{{feature}} isn't included in your plan",
    lockedBody: "Ask your organization owner to upgrade, or contact Malfak.",
  },
  names: { trial: "Trial", free: "Free", pro: "Pro", business: "Business" },
  status: { trial: "Trial", active: "Active", past_due: "Payment due" },
  features: {
    copilot: "Assistant",
    voice: "Voice",
    custom_dashboards: "Custom dashboards",
    calendar_intelligence: "Calendar intelligence",
    crisis_alerts: "Crisis alerts",
    automation_rules: "Automation rules",
    ai_replies: "AI replies and drafts",
    semantic_search: "Semantic search",
    commenter_enrichment: "Commenter enrichment",
    bulk_actions: "Bulk actions",
    exports: "Exports",
    approvals: "Approvals",
    customer_360: "Customer 360",
    api_access: "API access",
    channel_instagram: "Instagram",
    channel_facebook: "Facebook",
    channel_messenger: "Messenger",
    channel_whatsapp: "WhatsApp",
    byok: "Bring your own AI key",
  },
  groups: { ai: "AI", engagement: "Engagement", insights: "Insights", platform: "Platform", channels: "Channels" },
  limits: {
    channel_accounts: "Connected accounts",
    seats: "Team seats",
    ai_budget_usd: "AI budget",
    ai_tokens: "AI tokens",
    ai_rpm: "AI requests per minute",
    ai_tpm: "AI speed limit (per minute)",
    ai_images: "AI images",
    copilot_messages: "Assistant messages",
    active_rules: "Active automation rules",
    automation_runs: "Automation runs",
    scheduled_posts: "Scheduled posts",
    custom_dashboards: "Custom dashboards",
    backfill_posts: "Import depth (posts)",
    backfill_days: "Import depth (days)",
    storage_mb: "Storage",
    exports: "Exports",
    api_rpm: "API requests per minute",
    agent_replies: "AI agent replies",
  },
  periods: { none: "", day: "per day", month: "per month" },
  unlimited: "Unlimited",
  comingSoon: "Coming soon",
  errors: {
    aiBudget: "AI budget for this month is used up",
    aiBudgetReset: "It resets on {{date}}.",
    aiBudgetAdmin: "Your organization's AI budget for this month is used up. See Settings → Plan & billing, or contact Malfak.",
    limit: "{{what}}: limit reached ({{used}} of {{max}})",
    limitReset: "Resets on {{date}}.",
    feature: "{{what}} isn't included in your plan",
  },
  banner: {
    near: "{{what}}: {{pct}}% used ({{used}} of {{max}})",
    reached: "{{what}}: limit reached ({{used}} of {{max}})",
    dismiss: "Dismiss",
    view: "Plan & billing",
  },
  usage: {
    title: "Your plan",
    subtitle: "What your plan includes and how much you've used. Limits reset at the start of each period (midnight GMT).",
    plan: "Plan",
    status: "Status",
    trialEnds: "Trial ends {{date}}",
    trialEnded: "Trial ended: you're on Free now",
    included: "Included features",
    notIncluded: "Not included",
    usage: "Usage",
    resets: "Resets {{date}}",
    used: "{{used}} of {{max}}",
    usedUnlimited: "{{used}} used",
    setting: "Setting",
    adminsOnly: "Only owners and admins can see usage and billing.",
    summary: "Your organization is on {{plan}}.",
    askOwner: "Ask {{owners}} to change the plan.",
    askOwnerGeneric: "Ask an owner of your organization to change the plan.",
    technical: "Technical limits",
    technicalHint: "Speed limits that keep the service fast for everyone. Most organizations never reach them.",
    override: "Custom",
    expires: "until {{date}}",
  },
  billing: {
    title: "Billing",
    hint: "Online payment is coming soon. Your plan is managed by Malfak.",
    invoices: "Invoices",
    noInvoices: "No invoices yet",
    noInvoicesHint: "Invoices will appear here once online payment is live.",
    contact: "Contact us to change plan",
    contactTitle: "Change your plan",
    contactBody: "Tell us which plan you'd like and we'll switch it for you, usually within one working day.",
    email: "Email us",
    whatsapp: "Message us on WhatsApp",
    linkedin: "Message us on LinkedIn",
    message: "Hello Malfak, we'd like to change the plan for {{org}} (now {{plan}}).",
    copy: "Copy message",
    copied: "Message copied",
  },
};
